import React from "react";
import AddBasketLine from "../AddToBasketButton/AddBasketLine";

export default function NotAvailableItem({index, element, actions}) {
    return <div key={index} className="basket-item not-available">
        <div className="message">Товар {element.name} недоступен</div>
        <div className="button-remove">
            <AddBasketLine
                actions={actions}
                productId={element.id}
            />
        </div>
    </div>;
}